import { noticeError } from "../../../utils/newrelic/requests";
import { EnquiryRequest } from "../components/TradeInModal/Grading/types";

export interface HttpResponse {
  status: number;
  body?: unknown;
  error?: unknown;
}

function handleError(error: Error): HttpResponse {
  noticeError(`Notify API error: for create enquiry, error ${error}`);
  return { status: 400, error: "Create enquiry failed" };
}

export const createEnquiry = async (
  baseUrl: string,
  requestBody: EnquiryRequest,
): Promise<HttpResponse> => {
  const url = `${baseUrl}/api/v1/trade-in/enquiry`;
  return await fetch(url, {
    method: "POST",
    credentials: "omit",
    body: JSON.stringify(requestBody),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && (status >= 200 || status <= 299)) {
        return { status: status, body: await response.json() };
      }
      return { status: status, error: "Create enquiry failed" };
    })
    .catch((e) => handleError(e));
};
